import { motion } from "motion/react";
import { PageLayout } from "@/components/layout";

export default function TermsRoute() {
	return (
		<PageLayout>
			<section className="pt-16 md:pt-24 pb-16 md:pb-24 px-9 md:px-[8%] lg:px-[15%]">
				<div className="max-w-3xl mx-auto">
					<motion.h1
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.6, delay: 0.2 }}
						className="font-sans text-[28px] md:text-[32px] lg:text-[42px] font-normal tracking-tight text-white mb-4"
					>
						Terms of Use
					</motion.h1>
					<motion.p
						initial={{ opacity: 0, y: 15 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.5, delay: 0.35 }}
						className="text-[15px] text-white/30 mb-12"
					>
						Last updated: March 24, 2025
					</motion.p>

					<motion.div
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.5, delay: 0.4 }}
						className="space-y-10 text-[16px] text-white/50 leading-relaxed"
					>
						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Acceptance of Terms</h2>
							<p>
								By accessing or using the website at basilica.digital (the "Site") operated by Basilica Digital Inc. ("Basilica," "we," "us," or "our"), you agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use the Site.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Use of the Site</h2>
							<p>
								You may use the Site for lawful purposes only. You agree not to use the Site in any way that violates applicable laws or regulations, infringes on the rights of others, or interferes with the operation of the Site. We reserve the right to restrict or terminate your access at our discretion.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Intellectual Property</h2>
							<p>
								All content on the Site — including text, graphics, logos, images, software, and other materials — is the property of Basilica Digital Inc. or its licensors and is protected by applicable intellectual property laws. You may not reproduce, distribute, modify, or create derivative works from any content without our prior written consent.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">User Conduct</h2>
							<ul className="list-disc list-outside ml-5 space-y-2">
								<li>You will not attempt to gain unauthorized access to any part of the Site or its systems.</li>
								<li>You will not transmit any malicious code, viruses, or harmful data.</li>
								<li>You will not use automated tools to scrape, crawl, or extract data from the Site without permission.</li>
								<li>You will not impersonate any person or entity or misrepresent your affiliation.</li>
							</ul>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Disclaimer of Warranties</h2>
							<p>
								The Site and its content are provided "as is" and "as available" without warranties of any kind, either express or implied. We do not warrant that the Site will be uninterrupted, error-free, or free of harmful components. Your use of the Site is at your sole risk.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Limitation of Liability</h2>
							<p>
								To the fullest extent permitted by law, Basilica Digital Inc. shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of or inability to use the Site, even if we have been advised of the possibility of such damages.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Third-Party Links</h2>
							<p>
								The Site may contain links to third-party websites or services. We do not endorse or assume responsibility for the content, privacy policies, or practices of any third-party sites. You access them at your own risk.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Indemnification</h2>
							<p>
								You agree to indemnify and hold harmless Basilica Digital Inc., its officers, directors, employees, and agents from any claims, liabilities, damages, losses, or expenses arising from your use of the Site or violation of these Terms.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Governing Law</h2>
							<p>
								These Terms of Use are governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law provisions. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts located in Santa Cruz County, California.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Changes to These Terms</h2>
							<p>
								We reserve the right to modify these Terms of Use at any time. Changes will be posted on this page with an updated revision date. Your continued use of the Site after any changes constitutes acceptance of the revised terms.
							</p>
						</div>

						<div>
							<h2 className="text-[20px] text-white font-medium tracking-tight mb-3">Contact Us</h2>
							<p>
								If you have questions about these Terms of Use, please contact us at:
							</p>
							<div className="mt-3 text-white/70">
								<p>Basilica Digital Inc.</p>
								<p>100 Enterprise Way</p>
								<p>Scotts Valley, CA 95066</p>
								<p className="mt-2">
									<a href="mailto:contact@basilica.digital" className="text-white/70 hover:text-white underline underline-offset-2 transition-colors">contact@basilica.digital</a>
								</p>
							</div>
						</div>
					</motion.div>
				</div>
			</section>
		</PageLayout>
	);
}
